import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './CanceledTournament.styles';

export const CanceledTournament: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Tournament has been cancelled.</Typography>
      <Typography className={classes.description}>
        Get back out there and join another one!
      </Typography>
    </Box>
  );
};
